import { render } from "./WhatsappWidget.vue?vue&type=template&id=3b9337a0&scoped=true"
import script from "./WhatsappWidget.vue?vue&type=script&lang=js"
export * from "./WhatsappWidget.vue?vue&type=script&lang=js"

import "./WhatsappWidget.vue?vue&type=style&index=0&id=3b9337a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9337a0"]])

export default __exports__